export const getAnnotationLink = (ttsHash: string) =>
  `${
    process.env.REACT_APP_TTS_ANNOTATIONS_CLOUDFRONT_BUCKET
  }/tts_metadata/${ttsHash.slice(0, 8)}/${ttsHash}`;
